module.exports = __webpack_public_path__ + "static/audio-752cef99fab52c793fd26ff93faa22f5.mp3";